//dialog base function

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useTheme,
  Box,
} from "@mui/material";
import { alpha } from "@mui/system";
import { EditOutlined } from "@mui/icons-material";

export default function DialogBase(props) {
  const { open, title, children, onClose, validateFields, icon, actions } =
    props;

  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: "16px",
          overflow: "hidden",
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
          backgroundImage:
            theme.palette.mode === "dark"
              ? "linear-gradient(rgba(44, 52, 62, 0.9), rgba(33, 43, 54, 0.9))"
              : "linear-gradient(rgba(255, 255, 255, 0.9), rgba(245, 247, 250, 0.9))",
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor:
            theme.palette.mode === "dark"
              ? alpha(theme.palette.primary.dark, 0.15)
              : alpha(theme.palette.primary.main, 0.05),
          p: 3,
          borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            borderRadius: "10px",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.primary.main,
          }}
        >
          {icon || <EditOutlined fontSize="medium" />}
        </Box>
        {title}
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>{children}</DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          bgcolor:
            theme.palette.mode === "dark"
              ? alpha(theme.palette.background.paper, 0.4)
              : alpha(theme.palette.background.paper, 0.7),
        }}
      >
        {actions ? (
          actions
        ) : (
          <>
            <Button variant="contained" color="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={validateFields}
            >
              Confirm
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
